"use strict";

exports.__esModule = true;
exports.MediaUtils = void 0;
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
var _wixMedia = /*#__PURE__*/new WeakMap();
class MediaUtils {
  static of(wixMedia) {
    return new MediaUtils(wixMedia);
  }
  constructor(wixMedia) {
    _classPrivateFieldInitSpec(this, _wixMedia, void 0);
    _classPrivateFieldSet(_wixMedia, this, wixMedia);
  }
  convertToUrl(value) {
    const mediaItem = _classPrivateFieldGet(_wixMedia, this).parseMediaItemUri(value);
    if (mediaItem.error) {
      throw new Error('MediaUtils: Failed to convert wix media uri to URL', {
        cause: mediaItem.error
      });
    }
    switch (mediaItem.type) {
      case _classPrivateFieldGet(_wixMedia, this).types.IMAGE:
        return _classPrivateFieldGet(_wixMedia, this).getScaleToFillImageURL(mediaItem.mediaId, mediaItem.width, mediaItem.height, mediaItem.width, mediaItem.height, {
          name: mediaItem.title
        });
      case _classPrivateFieldGet(_wixMedia, this).types.VIDEO:
        return `https://video.wixstatic.com/video/${mediaItem.mediaId}/file`;
      case _classPrivateFieldGet(_wixMedia, this).types.AUDIO:
        return `https://static.wixstatic.com/mp3/${mediaItem.mediaId}`;
      default:
        throw new Error('MediaUtils: Unsupported media type');
    }
  }
}
exports.MediaUtils = MediaUtils;
//# sourceMappingURL=media-utils.js.map